import React, { memo } from 'react';

const WarningInner = () => (
    <svg viewBox="0 0 20 18">
        <path d="M10 0.138C10.742 0.138 11.42 0.545 11.768 1.2L19.107 15.064C19.438 15.69 19.417 16.426 19.053 17.032C18.688 17.638 18.047 18 17.339 18H2.661C1.953 18 1.313 17.638 0.948001 17.032C0.583001 16.425 0.563001 15.69 0.894001 15.064L8.232 1.201C8.58 0.545001 9.258 0.138 10 0.138ZM10 2.137L2.661 16H17.344L10 2.137ZM11.001 7H9.001V12H11.001V7ZM11 13H9V15H11V13Z" />
    </svg>
);

export const Warning = memo(WarningInner);
